import * as React from "react";

const EM = (props: { style?: React.CSSProperties; children?: React.ReactNode }) => (
  <span style={{ fontWeight: 600 }}>{props.children}</span>
);

export { EM, EM as Bold };
